export const useLoginWall = () => {
  const { $config } = useNuxtApp()
  const isLoginWallEnabled = $config.public.flagDisableLoginWall !== 'true'
  return { isLoginWallEnabled }
}
